import React from "react";
import { ParentsUIProvider } from "./ParentsUIContext";
import { ParentsCard } from "./ParentsCard";

export function ParentsPage({
  receipentType,
  noticeId
}) {
  return (
    <ParentsUIProvider noticeId={noticeId}>
      <ParentsCard
        receipentType={receipentType}
      />
    </ParentsUIProvider>
 );
}